import AuthUser, { AuthUserType } from './AuthUser';
import * as FullStory from '@fullstory/browser';
import {
  GetAppcuesUserObject,
  GetFullStoryUserObject,
  GetSentryUserObject,
  GetHeapUserObject,
} from './Helper';
import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';
import { Integrations } from '@sentry/tracing';
import Vue from 'vue';
import { ProcessEnv } from '../types';

declare let window: any;
declare let process: ProcessEnv;

const config = {
  workspace: {
    vwo: {
      enabled: false,
    },
    heap: {
      enabled: true,
      id: '193321016',
    },
    fullstory: {
      enabled: true,
    },
    sentry: {
      enabled: true,
      dns: 'https://f1debf8257be4e2690b4673d5f2df03a@o439795.ingest.sentry.io/5669432',
    },
    appcues: {
      enabled: true,
    },
  },
  property: {
    vwo: {
      enabled: false,
    },
    heap: {
      enabled: true,
      id: '193321016',
    },
    fullstory: {
      enabled: true,
    },
    sentry: {
      enabled: true,
      dns: 'https://97ce35e23089464686f713eef5823701@o439795.ingest.sentry.io/5416163',
    },
    appcues: {
      enabled: true,
    },
  },
  admin: {
    vwo: {
      enabled: false,
    },
    heap: {
      enabled: true,
      id: '3275439492',
    },
    fullstory: {
      enabled: true,
    },
    sentry: {
      enabled: true,
      dns: 'https://e6282b34f25c4286aad3cf98f0c6e096@o439795.ingest.sentry.io/5416010',
    },
    appcues: {
      enabled: true,
    },
  },
  reports: {
    vwo: {
      enabled: false,
    },
    heap: {
      enabled: true,
      id: '193321016',
    },
    fullstory: {
      enabled: true,
    },
    sentry: {
      enabled: true,
      dns: 'https://b99ef1250d844cf29f63d60f7c7add83@o439795.ingest.sentry.io/5416008',
    },
    appcues: {
      enabled: true,
    },
  },
  imageserver: {
    vwo: {
      enabled: false,
    },
    heap: {
      enabled: false,
      id: '',
    },
    fullstory: {
      enabled: false,
    },
    sentry: {
      enabled: true,
      dns: 'https://d21f206ddaf845dbb7a053309ac0be03@o439795.ingest.sentry.io/5669430',
    },
    appcues: {
      enabled: false,
    },
  },
  manage: {
    vwo: {
      enabled: true,
    },
    heap: {
      enabled: true,
      id: '193321016',
    },
    fullstory: {
      enabled: true,
    },
    sentry: {
      enabled: false,
      dns: 'https://f1debf8257be4e2690b4673d5f2df03a@o439795.ingest.sentry.io/5669432',
    },
    appcues: {
      enabled: true,
    },
  },
};

enum ApplicationString {
  workspace = 'workspace',
  property = 'property',
  admin = 'admin',
  reports = 'reports',
  imageserver = 'imageserver',
  manage = 'manage',
}

// Declaring heap variable for memory access
window.heap = window.heap || [];

const analytics = (application: ApplicationString) => {
  // Non existing applications
  if (!config[application])
    throw `Application ${application} doesn't exist in analytic config`;

  return {
    // Initializing setup code
    init() {
      if (config[application].vwo.enabled && !(window?._vwo_code)) {
        /**
         * Injects VWO snippet at the end of <head>.
         */
        const script = `
          window._vwo_code = window._vwo_code || (function(){
          var account_id=549284,
          settings_tolerance=2000,
          library_tolerance=2500,
          use_existing_jquery=false,
          is_spa=1,
          hide_element='body',

          /* DO NOT EDIT BELOW THIS LINE */
          f=false,d=document,code={use_existing_jquery:function(){return use_existing_jquery;},library_tolerance:function(){return library_tolerance;},finish:function(){if(!f){f=true;var a=d.getElementById('_vis_opt_path_hides');if(a)a.parentNode.removeChild(a);}},finished:function(){return f;},load:function(a){var b=d.createElement('script');b.src=a;b.type='text/javascript';b.innerText;b.onerror=function(){_vwo_code.finish();};d.getElementsByTagName('head')[0].appendChild(b);},init:function(){
          window.settings_timer=setTimeout(function () {_vwo_code.finish() },settings_tolerance);var a=d.createElement('style'),b=hide_element?hide_element+'{opacity:0 !important;filter:alpha(opacity=0) !important;background:none !important;}':'',h=d.getElementsByTagName('head')[0];a.setAttribute('id','_vis_opt_path_hides');a.setAttribute('type','text/css');if(a.styleSheet)a.styleSheet.cssText=b;else a.appendChild(d.createTextNode(b));h.appendChild(a);this.load('https://dev.visualwebsiteoptimizer.com/j.php?a='+account_id+'&u='+encodeURIComponent(d.URL)+'&f='+(+is_spa)+'&r='+Math.random());return settings_timer; }};window._vwo_settings_timer = code.init(); return code; }());
        `;
        eval(script);
      }

      if (config[application].heap.enabled) {
        const script = `
          heap.load = function (appId, heapConfig) {
            window.heap.appid = appId;
            window.heap.config = heapConfig || {};
        
            const script = document.createElement("script");
            script.type = "text/javascript";
            script.async = true;
            script.src = "https://cdn.heapanalytics.com/js/heap-" + appId + ".js";
            
            const firstScript = document.getElementsByTagName("script")[0];
            firstScript.parentNode.insertBefore(script, firstScript);
            
            const cloneArray = (arrayLike) => Array.prototype.slice.call(arrayLike, 0);
        
            const createMethod = function (method) {
                return function () {
                    heap.push([
                        method,
                        ...cloneArray(arguments)
                    ]);
                }
            };
        
            const methods = [
                'addEventProperties',
                'addUserProperties',
                'clearEventProperties',
                'identify',
                'resetIdentity',
                'removeEventProperty',
                'setEventProperties',
                'track',
                'unsetEventProperty',
            ];
            
            for (let method of methods) {
                heap[method] = createMethod(method)
            }
          };
          
          heap.load("${config[application].heap.id}");
        `;

        eval(script);
      }

      if (config[application].fullstory.enabled) {
        FullStory.init({
          orgId: 'JCSJV',
          devMode:
            process.env.NODE_ENV === 'development' ||
            process.env.NODE_ENV === 'local',
        });
      }

      if (config[application].sentry.enabled) {
        Sentry.init({
          dsn: config[application].sentry.dns,
          integrations: [
            new Integrations.BrowserTracing(),
            new VueIntegration({ Vue, attachProps: true, tracing: true }),
          ],
          tracesSampleRate: 0.3,
        });
      }

      if (config[application].appcues.enabled) {
        /**
         * Injects Appcues snippet at the end of <head>.
         * Creates window.appcues, that'll get used by routing and identify later
         */
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = '//fast.appcues.com/69276.js';
        document.getElementsByTagName('head')[0].appendChild(script);
      }
    },

    // Setting identity for analytic services that allow it
    identify(authUser: AuthUserType = AuthUser) {
      try {
        window.onload = async () => {
          if (!authUser.guid) await authUser.fetch();

          if (authUser?.guid) {
            if (config[application].fullstory.enabled) {
              // Fullstory
              FullStory.identify(authUser.guid, GetFullStoryUserObject(authUser));
            }


            if (config[application].appcues && window?.Appcues) {
              // Appcues
              window?.Appcues?.identify(
                authUser.guid,
                GetAppcuesUserObject(authUser)
              );
            }

            if (config[application].sentry.enabled) {
              // Sentry
              Sentry.setUser(GetSentryUserObject(authUser));
            }

            if (config[application].heap && window?.heap) {
              // Heap.io
              window.heap.identify(authUser.guid);
              window.heap.addUserProperties(GetHeapUserObject(authUser));
            }
          }
        }
      } catch (error) {
        console.error(
          new Error(
            `There was an issue with analytics identification. ${error}`
          )
        );
      }

    },
  };
};

export default {
  workspace: analytics(ApplicationString.workspace),
  property: analytics(ApplicationString.property),
  admin: analytics(ApplicationString.admin),
  reports: analytics(ApplicationString.reports),
  imageserver: analytics(ApplicationString.imageserver),
  manage: analytics(ApplicationString.manage),
};
